import React from "react";
import './MobileChatScreen.css'
import {Link} from "react-router-dom";
import backIcon from "../../../imgs/back_arrow.png";

export default function MobileChatScreen() {
    return <div className="Mobile_chat_container">
        <div className="Mobile_chat_container_navbar">
            <span className="Mobile_chat_container_header_title">Регистрация в драйве</span>
            <Link to="/" className="Mobile_chat_container_header_arrow">
                <img src={backIcon} style={{width: "11px", height: "21px"}}/>
            </Link>
        </div>
        <iframe src="https://l7test.yandex.ru/drive/b2c/web/index.html" style={{
            height: "100vh",
            width: "100%",
            position: "absolute",
            zIndex: 99,
            backgroundColor: "#F5F5F5",
            border: "none"
        }}/>
    </div>
}